
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import {
  People,
  TrendingUp,
  Work,
  EmojiObjects,
  Female,
  School,
} from "@mui/icons-material";

const statItems = [
  {
    title: "Total Placements",
    value: "109616",
    subtitle: "Cumulative placements",
    icon: <People fontSize="large" className="text-orange-500" />,
  },
  {
    title: "Average Annual Growth",
    value: "50%",
    subtitle: "2021–2025",
    icon: <TrendingUp fontSize="large" className="text-orange-500" />,
  },
  {
    title: "Full-Time Employment",
    value: "40%",
    subtitle: "Of total placements",
    icon: <Work fontSize="large" className="text-orange-500" />,
  },
  {
    title: "Self-Employment",
    value: "13254",
    subtitle: "Entrepreneurs supported",
    icon: <EmojiObjects fontSize="large" className="text-orange-500" />,
  },
  {
    title: "Women Placement Rate",
    value: "32.9%",
    subtitle: "Target: 75%",
    icon: <Female fontSize="large" className="text-orange-500" />,
  },
  {
    title: "University CDCs",
    value: "29",
    subtitle: "Career Development Centers",
    icon: <School fontSize="large" className="text-orange-500" />,
  },
];

const universities = [
  {
    name: "Hawassa University",
    placementPct: "8.9%",
    actual: "9801",
    femalePct: "30.3%",
  },
   {
    name: "University of Gondar",
    placementPct: "6.6%",
    actual: "7314",
    femalePct: "35.7%",
  },
  {
    name: "Jimma University",
    placementPct: "6.4%",
    actual: "7026",
    femalePct: "30.4%",
  },
 
];

const chartData = [
  { sector: "Service", Female: 18456, Male: 38122},
  { sector: "Engineering", Female: 1930, Male: 5842 },
  { sector: "Education", Female: 2206, Male: 4887 },
  { sector: "Finance", Female: 2778, Male: 4058 },
  { sector: "Other", Female: 1629, Male: 4758},
  { sector: "Business", Female: 1949, Male: 4381 },
   { sector: "Information Technology", Female: 1353, Male: 4369 },
   { sector: "Health Care", Female: 1773, Male: 3237 },
  { sector: "Sales", Female: 1452, Male: 1830 },
  { sector: "Agriculture", Female: 404, Male: 1157 },
   { sector: "Construction", Female: 318, Male: 942 },
  { sector: "Manufacturing", Female: 239, Male: 599 },
  { sector: "NGOs", Female: 243, Male: 364 },
  { sector: "Advertisment", Female: 117, Male: 223 },
  
];

const selfEmployedChartData = [
  { sector: "Business", Total:3342},
  { sector: "Other", Total:2978},
  { sector: "Service", Total:2466},  
  { sector: "Engineering", Total:1056 },
  { sector: "Information Technology", Total:834},
  { sector: "Finance", Total:434},
  { sector: "Agriculture", Total:430},
  { sector: "Education",Total:404 },
  { sector: "Health Care",Total:401 },
  { sector: "Sales", Total:310},
  { sector: "Construction", Total:285 },
  { sector: "Advertisment",Total:179 },
  { sector: "Manufacturing", Total:81},
  { sector: "NGOs", Total:54},
];

export default function App() {
  return (
    <div className="bg-gray-50 min-h-screen p-4 space-y-6 font-sans text-sm">
      <h1 className="text-2xl font-bold text-orange-500">📊 Program Review Summary</h1>

      {/* Stat Boxes */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {statItems.map((item, idx) => (
          <div
            key={idx}
            className="bg-white rounded-lg shadow-sm hover:shadow-md transition p-3 flex flex-col items-center text-center space-y-1"
          >
            <div className="bg-orange-100 rounded-full p-1.5">
              {React.cloneElement(item.icon, { fontSize: "small" })}
            </div>
            <div className="text-base font-semibold text-gray-800">{item.value}</div>
            <div className="text-xs text-gray-600 font-medium">{item.title}</div>
            <div className="text-[10px] text-gray-400">{item.subtitle}</div>
          </div>
        ))}
      </div>

      {/* Program Reach + University Table */}
      <div className="grid lg:grid-cols-2 gap-4">
        <div className="bg-white p-4 rounded shadow space-y-2">
          <h3 className="font-semibold text-orange-500">Program Reach</h3>
          <div className="text-xl font-bold text-orange-900">269,438</div>
          <div className="text-xs text-gray-500">Youth Reached</div>
          <div className="flex justify-between text-xs text-gray-700">
            <span>109,616 Placements</span>
            <span>37.5%</span>
          </div>
          <div className="w-full bg-gray-200 h-2 rounded">
            <div
              className="h-2 bg-orange-500 rounded"
              style={{ width: "37.5%" }}
            ></div>
          </div>
        </div>

        <div className="overflow-x-auto bg-white rounded-lg shadow p-4">
          <table className="min-w-full text-xs text-gray-700 text-left border-collapse">
            <thead>
              <tr className="bg-orange-500 text-white">
                <th className="p-2 font-semibold">Top 3 Contributing Universities</th>
                <th className="p-2 font-semibold">% Placements</th>
                <th className="p-2 font-semibold"># Actual Placements</th>
                <th className="p-2 font-semibold">% Female placements</th>
              </tr>
            </thead>
            <tbody>
              {universities.map((u, i) => (
                <tr
                  key={i}
                  className={`${i % 2 === 0 ? "bg-gray-50" : "bg-white"} hover:bg-purple-50 transition`}
                >
                  <td className="p-2">{u.name}</td>
                  <td className="p-2 text-purple-600 font-medium">{u.placementPct}</td>
                  <td className="p-2 font-medium">{u.actual}</td>
                 
                  
                  <td className="p-2 text-purple-600 font-semibold">{u.femalePct}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Gender Sector Charts */}
      <div className="bg-white p-4 rounded-lg shadow grid lg:grid-cols-2 gap-4">
        {/* Chart 1: Employed Sector */}
        <div className="w-full overflow-x-auto">
          <h3 className="text-lg font-bold text-orange-500 mb-2 text-center">
            Sector Placement by Gender
          </h3>
          <div className="min-w-[600px] h-[300px]">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={chartData} margin={{ top: 20, right: 30, left: 0, bottom: 50 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="sector"
                  angle={-45}
                  textAnchor="end"
                  height={70}
                  interval={0}
                  tick={{ fill: "#4B5563", fontSize: 12 }}
                />
                <YAxis tick={{ fill: "#6B7280", fontSize: 12 }} />
                <Tooltip formatter={(value) => [value, "Count"]} />
                <Legend />
                <Bar dataKey="Female" fill="#f59e0b" barSize={20} />
                <Bar dataKey="Male" fill="#dc2626" barSize={20} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Chart 2: Self-Employed */}
        <div className="w-full overflow-x-auto">
          <h3 className="text-lg font-bold text-orange-500 mb-2 text-center">
            Self-Employed Sector by Gender
          </h3>
          <div className="min-w-[600px] h-[300px]">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={selfEmployedChartData} margin={{ top: 20, right: 30, left: 0, bottom: 50 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="sector"
                  angle={-45}
                  textAnchor="end"
                  height={70}
                  interval={0}
                  tick={{ fill: "#4B5563", fontSize: 12 }}
                />
                <YAxis tick={{ fill: "#6B7280", fontSize: 12 }} />
                <Tooltip formatter={(value) => [value, "Count"]} />
                <Legend />
               
                <Bar dataKey="Total" fill="#dc2626" barSize={20} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
    
  );
}







